
    const data = {"name":"src/core/icons/alert","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 14h-2V9h2m0 9h-2v-2h2M1 21h22L12 2 1 21Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            